import { render, staticRenderFns } from "./search-box.vue?vue&type=template&id=64d04d9a&scoped=true&"
import script from "./search-box.vue?vue&type=script&lang=ts&"
export * from "./search-box.vue?vue&type=script&lang=ts&"
import style0 from "./search-box.vue?vue&type=style&index=0&id=64d04d9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d04d9a",
  null
  
)

export default component.exports